export enum UserColumns {
  LAST_NAME,
  FIRST_NAME,
  PROFILE,
  EMAIL,
  GROUPS,
  STATUS,
}
